import { chartBackgroundColors } from "./constants"

export let colorIndex = 0
export const getChartColor = () => {
  if (colorIndex >= chartBackgroundColors.length) {
    colorIndex = 0
  }
  const color = chartBackgroundColors[colorIndex]
  colorIndex = colorIndex + 1
  return color
}